export const SKILLS = [
  // 'ploughing-laborer',
  'farm-worker',
  'sower',
  'paddy-spreader',
  'tractor-driver',
  'ownertc',
  'harvester',
  'harvester-operator',
  'owner-harvester',
  'pesticide-applicator',
  'fertilizer-applicator',
  'grass-cutter',
  'cow-milker',
  'buffalo-milker',
  'ploughman-with-bull',
  'crop-sorter',
  'watering-laborer',
  'dung-cleaner',
  'bullockcart-owner',
  'bullock-cart-only',
  'bullock-cart-driver',
  'e-crop-survey-assistant',
  'paddy-bundling',
  'bag-lifting'
];

export const SKILL_LABELS = {
  'farm-worker': {
    english: 'Farm Worker',
    hindi: 'खेती मजदूर',
    marathi: 'शेतमजूर(सर्व शेती कामे)',
  },
  'tractor-driver': {
    english: 'Tractor Driver (Only)',
    hindi: 'सिर्फ ट्रैक्टर चालक',
    marathi: 'फक्त ट्रॅक्टर चालक',
  },
  'ownertc': {
    english: 'Tractor Owner (Driver + Tractor)',
    hindi: 'ट्रैक्टर मालिक (ड्राइवर सहित)',
    marathi: 'ट्रॅक्टर मालक (ड्रायव्हरसह सेवा)',
  },
  'sower': {
    english: 'Sower',
    hindi: 'पेंडकर',
    marathi: 'पेंडकर',
  },
  'irrigation-specialist': {
    english: 'Irrigation Specialist',
    hindi: 'सिंचाई विशेषज्ञ',
    marathi: 'सिंचन तज्ज्ञ',
  },
  'harvester-operator': {
    english: 'Harvester Operator (Only)',
    hindi: 'सिर्फ हार्वेस्टर चालक',
    marathi: 'फक्त हार्वेस्टर चालक',
  },
  'owner-harvester': {
    english: 'Harvester Owner (Machine + Driver)',
    hindi: 'हार्वेस्टर मालिक (मशीन + चालक)',
    marathi: 'हार्वेस्टर मालक (मशीन व चालकासह)',
  },
  'harvester': {
    english: 'Harvester',
    hindi: 'फसल काटने वाला',
    marathi: 'पीक कापणारा',
  },
  'pesticide-applicator': {
    english: 'Pesticide Applicator',
    hindi: 'कीटनाशक छिड़कने वाला',
    marathi: 'कीटकनाशक फवारणारा',
  },
  'ploughing-laborer': {
    english: 'Ploughing Laborer',
    hindi: 'जुताई मजदूर',
    marathi: 'रोवणी शेतमजूर',
  },
  'crop-sorter': {
    english: 'Crop Sorter',
    hindi: 'फसल छांटने वाला',
    marathi: 'निंदण करणारा',
  },
  'grass-cutter': {
    english: 'Grass Cutter',
    hindi: 'घास काटने वाला',
    marathi: 'गवत कापणारा',
  },
  'cow-milker': {
    english: 'Cow Milker',
    hindi: 'गाय दुहने वाला',
    marathi: 'गायीचे दूध काढणारा',
  },
  'fertilizer-applicator': {
    english: 'Fertilizer Applicator',
    hindi: 'खाद डालने वाला',
    marathi: 'खत मारणारा',
  },
  'watering-laborer': {
    english: 'Watering Laborer',
    hindi: 'पानी देने वाला',
    marathi: 'पाणी देणारा',
  },
  'paddy-spreader': {
    english: 'Paddy Spreader',
    hindi: 'धान फैलाने वाला (हाथ से)',
    marathi: 'परे फोकणारा',
  },
  'buffalo-milker': {
    english: 'Buffalo Milker)',
    hindi: 'भैंस दुहने वाला',
    marathi: 'म्हशीचे दूध काढणारा',
  },
  'ploughman-with-bull': {
    english: 'Ploughman (with Bulls)',
    hindi: 'बैल से हल चलाने वाला',
    marathi: 'बैलासह नांगरणारा',
  },
  'dung-cleaner': {
    english: 'Cow Dung Cleaner',
    hindi: 'गोबर साफ करने वाला',
    marathi: 'शेण साफ करणारा',
  },
  'bullockcart-owner': {
    english: 'Bullock Cart Owner (with Driver)',
    hindi: 'बैलगाड़ी मालिक (चालक सहित)',
    marathi: 'बैलगाडी मालक (चालकासह)',
  },
  'bullock-cart-only': {
    english: 'Bullock Cart (Only)',
    hindi: 'सिर्फ बैलगाड़ी',
    marathi: 'फक्त बैल गाडी',
  },
  'bullock-cart-driver': {
    english: 'Bullock Cart Driver (Only)',
    hindi: 'सिर्फ बैलगाड़ी चालक',
    marathi: 'बैल गाडी चालक',
  },
  'e-crop-survey-assistant': {
    english: 'e-Crop Survey Assistant',
    hindi: 'ई-फसल सर्वेक्षण सहायक',
    marathi: 'ई-पीक पाहणी मदतनिस',
  },
  'paddy-bundling': {
    english: 'Paddy Bundling',
    hindi: 'धान बांधना',
    marathi: 'धान बांधणे',
  },

  'bag-lifting': {
    english: 'Bag Lifting',
    hindi: 'बोरी उठाना',
    marathi: 'धानाची पोती उचलणे',
  },

};


export const VEHICLE_SKILLS = [
  'bike',
  'uv-auto',
  'omni',
  'tata-magic',
  'bolero',
];

export const VEHICLE_SKILL_LABELS = {
  bike: {
    english: 'Bike',
    hindi: 'बाइक',
    marathi: 'बाईक',
  },
  'uv-auto': {
    english: 'UV Auto',
    hindi: 'इलेक्ट्रिक ऑटो',
    marathi: 'इलेक्ट्रिक ऑटो',
  },
  omni: {
    english: 'Omni',
    hindi: 'ओमनी',
    marathi: 'ओमनी',
  },
  'tata-magic': {
    english: 'Tata Magic',
    hindi: 'टाटा मॅजिक',
    marathi: 'टाटा मॅजिक',
  },
  bolero: {
    english: 'Bolero',
    hindi: 'बोलेरो',
    marathi: 'बोलेरो',
  },
};

export default SKILLS;